'use strict';

angular.module('mean.contractors').config(['$stateProvider', function($stateProvider) {

    var checkLoggedin = function($q, $timeout, $http, $location) {

      var deferred = $q.defer();

      $http.get('/loggedin').success(function(user) {
        if (user !== '0') $timeout(deferred.resolve);
        else {
          $timeout(deferred.reject);
          $location.url('/login');
        }
      });
      return deferred.promise;
    };

    $stateProvider
    	.state('mtc', {
      	  url: '/mtc',
      	  templateUrl: 'contractors/views/index.html',
      	  resolve: {
          loggedin: checkLoggedin
        }
    })
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/contractors/public/routes/contractors.js